import type { FunctionComponent } from 'react';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Analytics } from '@trello/atlassian-analytics';
import { Button } from '@trello/nachos/button';
import { PopoverPlacement, usePopover } from '@trello/nachos/popover';

import { CreateBoardPopover } from 'app/src/components/CreateBoardPopover';

import styles from './BlankBoardTile.less';

export const BlankBoardTile: FunctionComponent = () => {
  const { triggerRef, toggle, show, hide, popoverProps, push, pop } =
    usePopover<HTMLButtonElement>({
      placement: PopoverPlacement.RIGHT_START,
    });

  const handleAddBoardClick = useCallback(() => {
    Analytics.sendClickedButtonEvent({
      buttonName: 'startWithBlankBoardTileButton',
      source: 'templateGalleryScreen',
    });
    toggle();
  }, [toggle]);

  return (
    <>
      <Button
        className={styles.boardTile}
        onClick={handleAddBoardClick}
        ref={triggerRef}
      >
        <span className={styles.startWithBoardText}>
          <FormattedMessage
            id="templates.templates.start-with-a-blank-board"
            defaultMessage="Start with a blank board"
            description="Start with a blank board"
          />
        </span>
      </Button>
      <CreateBoardPopover
        analyticsSource="templateCategoryScreen"
        show={show}
        hide={hide}
        pop={pop}
        popoverProps={popoverProps}
        push={push}
      />
    </>
  );
};
